<template>
  <div class="container">
    <el-row :gutter="20">
      <el-col :span="6">
        <h2>个人中心</h2>
        <el-menu
          :default-active="currentIndex"
          mode="vertical"
          @select="handleSelect"
        >
          <el-menu-item index="1">个人资料</el-menu-item>
          <el-menu-item index="2">安全设置</el-menu-item>
          <el-menu-item index="3">区域切换</el-menu-item>
        </el-menu>
      </el-col>
      <el-col :span="18">
        <personal-info v-if="currentIndex === '1'" />
        <security-set v-else-if="currentIndex === '2'" />
        <div v-else>
          <div class="area_select">
           
            <div class="area_select_box">
               <h2>请选择您的地区</h2>
               <div class="content_box">
                 <div   v-for="(x, y) in list"
                    :key="y" @click="handleCommand(x)">
                    <img :src="x.url" alt="">
                    <p>{{ x.serviceName }}</p>
                    <div>进入主页</div>
                    </div>
               </div>
              <!-- <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ name }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    :command="x"
                  
                    >{{ x.serviceName }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown> -->
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import personalInfo from "./personInfo/personalInfo";
import securitySet from "./personInfo/securitySet";
import {getName,removeToken} from "@/utils/auth";

export default {
  components: {
    personalInfo,
    securitySet,
  },
  data() {
    return {
      currentIndex: "1",
      name:'',
      list:[],
    };
  },
  created() {
    let index = this.$route.params.index;
    if (index) {
      this.currentIndex = index;
    }
    this.appservice()
  },
  methods: {
    handleSelect(key) {
      this.currentIndex = key;
    },
        appservice() {
          let config = {
              headers: { "Content-Type": "application/json;charset=UTF-8" },
               limit:10,
                page:1,
      };
      // let url;
      //    if(process.env.NODE_ENV=="development"){
      //   url="http://baise-portal-api.baise.whdev.vpclub.cn/"
         
      // }else{
      //   url='http://portal-api.baise.vpclub.cn/'
      // }
      this.$request.post("/api/web/appservice/list",config).then((res) => {
        console.log(res);
        if (res.code != 0) {
          return this.$message.error(res.msg);
        }
        this.list = res.data.list;
        this.name=getName()?getName():this.list[0].serviceName
         
        
      });
    },
    handleCommand(x) {
     
      if(this.name===x.serviceName){
        this.$message.error("当前已在"+this.name)
        return
      }
         removeToken()
       window.location.href=x.pcUrl;
      // setHomePage(x.pcUrl); 
      // setName(x.serviceName);
      // setPartnerId(x.partnerId);
      // setPayUrlKey(x.payUrl);
   
     
      // setTimeout(()=>{
        
      // },500)
       
       
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  width: 1440px;
  margin: 0 auto;
  .area_select_box{
    width:100%;
    padding: 30px 40px;
    margin:70px 0 0 0;
    background:#fff;
    min-height:400px;
    h2{
      text-align: center;
      // margin:0 auto;
      font-family: PingFangHK-Regular;
      font-size: 28px;
      color: #4A4A4A;
      letter-spacing: 0;
      text-align: center;
      line-height: 28px;
    }
    .content_box{
      display: flex;
      height:210px;
      margin:60px 0;
     justify-content: center;
      >div{
        width:190px;
        background: #FFFFFF;
        border: 1px solid #EEEEEE;
        margin:0 50px;
        padding:51px 0;
        box-sizing: border-box;
        img{
          width:50px;
          margin:0 auto;
          height:50px;
          display: block;
          border-radius: 50%;
        }
        >p{
          font-family: PingFangHK-Regular;
          font-size: 16px;
          color: #4A4A4A;
          letter-spacing: 0;
          text-align: center;
          line-height: 24px;
        }
        >div{
          border: 1px solid #346BFD;
          border-radius: 18px;
          border-radius: 18px;
          margin:0 auto;
          width:50px;
          padding:2px 5px;
          height:16px;
          line-height: 16px;
          font-size: 12px;
          color: #346BFD;
          cursor: pointer;
          
        }
       
      }
    }
  }
}
</style>